import { render, staticRenderFns } from "./TaskCheckList.vue?vue&type=template&id=5f1218ec&scoped=true&"
import script from "./TaskCheckList.vue?vue&type=script&lang=js&"
export * from "./TaskCheckList.vue?vue&type=script&lang=js&"
import style0 from "./TaskCheckList.vue?vue&type=style&index=0&id=5f1218ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1218ec",
  null
  
)

export default component.exports